import classNames from "classnames";
import typography from "PFTheme/styles/typography.scss";
import React from "react";
import { useTranslation } from "react-i18next";

import { SkillsManagementModalType } from "../parts/modals/import/constants/skills_management_modal_type";
import { SkillsManagementSidePanel } from "../parts/side_panel";
import { BulkActions } from "../table/header/bulk_actions";
import { useSkillManagementModal } from "../table/hooks/use_skill_management_modal";
import { ActionButtons } from "./action_buttons";
import css from "./skills_management_header.module.scss";

export const SkillsManagementHeader = (): JSX.Element => {
  const { t } = useTranslation("skillsManagement");
  const { openModal } = useSkillManagementModal();

  return (
    <div className={css.header}>
      <h1 className={classNames(css.titleRow, typography.typographyH1)}>
        {t("header.title")}
        <BulkActions />
        <ActionButtons
          onAddButtonClick={() => openModal(SkillsManagementModalType.Create)}
          onImportButtonClick={() => openModal(SkillsManagementModalType.Import)}
        />
      </h1>

      <SkillsManagementSidePanel />
    </div>
  );
};
